// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';

export class PushNotificationDevice {
  readonly id: string;
  readonly userId: string;
  readonly type: Enums.PushNotificationDeviceType;
  readonly token: string;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.userId = data.userId === undefined ? NIL_UUID : data.userId;
    this.type = data.type === undefined ? Enums.PushNotificationDeviceType.Web : data.type;
    this.token = data.token === undefined ? '' : data.token;
  }

  static zero(): PushNotificationDevice {
    const zeroValues: ExcludeMethodsDeep<PushNotificationDevice> = {
      id: NIL_UUID,
      userId: NIL_UUID,
      type: Enums.PushNotificationDeviceType.Web,
      token: '',
    };
    return new PushNotificationDevice(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type PushNotificationDeviceWireFormat = {
  id: string;
  userId: string;
  type: string;
  token: string;
};

type NewPushNotificationDeviceProps = PartialDeep<
  PushNotificationDevice,
  { recurseIntoArrays: true }
>;
export const NewPushNotificationDevice: (
  props: NewPushNotificationDeviceProps,
) => PushNotificationDevice = (props) => new PushNotificationDevice(props);

type NewPushNotificationDeviceFromWireFormatProps = PartialDeep<
  PushNotificationDeviceWireFormat,
  { recurseIntoArrays: true }
>;
export const NewPushNotificationDeviceFromWireFormat: (
  props: NewPushNotificationDeviceFromWireFormatProps,
) => PushNotificationDevice = (props) => new PushNotificationDevice(props);
